import { createFileRoute } from "@tanstack/react-router";

import { AdminCommunitiesList } from "@/components/admin/admin-communities-list";
import { useCurrentUser } from "@/hooks/use-current-account";

type CommunitiesSearch = {
  filter?: "low-activity" | "low-attendance" | "inactive";
};

export const Route = createFileRoute("/_authenticated/app/admin/communities")({
  validateSearch: (raw: Record<string, unknown>): CommunitiesSearch => {
    const f = raw.filter;
    if (f === "low-activity" || f === "low-attendance" || f === "inactive") return { filter: f };
    return {};
  },
  component: AdminCommunitiesPage,
});

function AdminCommunitiesPage() {
  const { filter } = Route.useSearch();
  const { data: user } = useCurrentUser();

  if (user && user.role !== "company_admin") {
    return null;
  }

  return <AdminCommunitiesList filter={filter} />;
}
